import { BoxProps, Flex, PopoverContent } from '@chakra-ui/react'
import { ForwardedRef, forwardRef } from 'react'
import React from 'react'
import { useCustomTooltipStyles } from '~/components/shared/componentStyles/CustomTooltip.style'
import { ZIndex } from '~/types/ThemeTypes'

export const CustomTooltipContainer = forwardRef(
  ({ children, ...rest }: BoxProps, ref: ForwardedRef<HTMLDivElement>) => {
    const styles = useCustomTooltipStyles()

    return (
      <Flex
        ref={ref}
        zIndex={ZIndex.popover}
        position="relative"
        sx={{ ...rest }}
      >
        <PopoverContent width="fit-content" bg="transparent">
          <Flex sx={styles.container}>{children}</Flex>
        </PopoverContent>
      </Flex>
    )
  },
)
